import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { ChecklistePositionPrioritaet } from '../Enums/ChecklistePositionPrioritaet.enum';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputChecklistePositionDirectEdit<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: any;
  /** Alias: checklisteCode */
  checklisteCode?: any;
  /** Alias: name */
  name?: any;
  /** Alias: datumErledigt */
  datumErledigt?: any;
  /** Alias: benutzerCodeErledigt */
  benutzerCodeErledigt?: any;
  /** Alias: notiz */
  notiz?: any;
  /** Alias: art */
  art?: any;
  /** Alias: nummer */
  nummer?: any;
  /** Alias: positionsNummer */
  positionsNummer?: any;
  /** Alias: kategorie1 */
  kategorie1?: any;
  /** Alias: kategorie2 */
  kategorie2?: any;
  /** Alias: farbe */
  farbe?: any;
  /** Alias: benutzerCodeGeplant */
  benutzerCodeGeplant?: any;
  /** Alias: bisWann */
  bisWann?: any;
  /** Alias: personGeplant */
  personGeplant?: any;
  /** Alias: checked */
  checked?: any;
  /** Alias: lieferantenCode */
  lieferantenCode?: any;
  /** Alias: prioritaet */
  prioritaet?: ChecklistePositionPrioritaet;
  /** Alias: vorlageProjektDatumBezug */
  vorlageProjektDatumBezug?: any;
  /** Alias: projektePlanungCode */
  projektePlanungCode?: any;
  /** Alias: beginntAm */
  beginntAm?: any;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputChecklistePositionDirectEdit> = {
  code: {
    alias: 'code',
  },
  checklisteCode: {
    alias: 'checklisteCode',
  },
  name: {
    alias: 'name',
  },
  datumErledigt: {
    alias: 'datumErledigt',
  },
  benutzerCodeErledigt: {
    alias: 'benutzerCodeErledigt',
  },
  notiz: {
    alias: 'notiz',
  },
  art: {
    alias: 'art',
  },
  nummer: {
    alias: 'nummer',
  },
  positionsNummer: {
    alias: 'positionsNummer',
  },
  kategorie1: {
    alias: 'kategorie1',
  },
  kategorie2: {
    alias: 'kategorie2',
  },
  farbe: {
    alias: 'farbe',
  },
  benutzerCodeGeplant: {
    alias: 'benutzerCodeGeplant',
  },
  bisWann: {
    alias: 'bisWann',
  },
  personGeplant: {
    alias: 'personGeplant',
  },
  checked: {
    alias: 'checked',
  },
  lieferantenCode: {
    alias: 'lieferantenCode',
  },
  prioritaet: {
    alias: 'prioritaet',
  },
  vorlageProjektDatumBezug: {
    alias: 'vorlageProjektDatumBezug',
  },
  projektePlanungCode: {
    alias: 'projektePlanungCode',
  },
  beginntAm: {
    alias: 'beginntAm',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputChecklistePositionDirectEditEntityDefinition: EntitiyDefinition<InputChecklistePositionDirectEdit> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputChecklistePositionDirectEdit',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
